/**
 * PDP main section: ingredients key list, scroll-to-block, sticky bar presence for layout.
 * Used by product__main.liquid. Sticky nav (product-pdp-sticky-nav.js) depends on scrollToBlock.
 */
(function() {
  'use strict';

  // --- Ingredients key list (editorial block) ---
  const INGREDIENTS_BREAKPOINT_PX = 480;
  const INGREDIENTS_DESKTOP_BREAKPOINT_PX = 990;
  const INGREDIENTS_MAX_HEIGHT_DESKTOP = '50vw';
  const INGREDIENTS_MAX_HEIGHT_MOBILE = '500px';
  const INGREDIENTS_MIN_HEIGHT_RATIO = 0.8;
  const INGREDIENTS_MIN_HEIGHT_MAX_DESKTOP = 600;
  const INGREDIENTS_MIN_HEIGHT_MAX_MOBILE = 400;

  function isIngredientsDesktop() {
    return window.innerWidth >= INGREDIENTS_DESKTOP_BREAKPOINT_PX;
  }

  const INGREDIENTS_VISIBLE_LINES = 14;

  /**
   * Split rich text paragraphs / line breaks into bordered rows while keeping inline HTML (e.g. bold).
   */
  function initIngredientsLineLayout() {
    const list = document.querySelector('[js-ingredients-list]');
    if (!list || list.dataset.linesBuilt === 'true') return;

    const source = list.querySelector('.metafield-rich_text_field') || list;
    const lineHtmlChunks = [];

    source.querySelectorAll('p').forEach(function(p) {
      p.innerHTML.split(/<br\s*\/?>/i).forEach(function(part) {
        const trimmed = part.trim();
        if (trimmed) lineHtmlChunks.push(trimmed);
      });
    });

    if (!lineHtmlChunks.length && source.innerHTML.trim()) {
      source.innerHTML.split(/<br\s*\/?>/i).forEach(function(part) {
        const trimmed = part.trim();
        if (trimmed) lineHtmlChunks.push(trimmed);
      });
    }

    if (!lineHtmlChunks.length) return;

    list.replaceChildren();
    lineHtmlChunks.forEach(function(html) {
      const line = document.createElement('div');
      line.className = 'pdp-ingredient-line';
      line.innerHTML = html;
      list.appendChild(line);
    });

    list.dataset.linesBuilt = 'true';
  }

  function initIngredientsTruncation() {
    const list = document.querySelector('[js-ingredients-list]');
    const toggleBtn = document.querySelector('[js-ingredients-toggle]');
    if (!list || !toggleBtn) return;

    const lines = list.querySelectorAll('.pdp-ingredient-line');
    if (lines.length <= INGREDIENTS_VISIBLE_LINES) return;

    lines.forEach(function(line, index) {
      if (index >= INGREDIENTS_VISIBLE_LINES) {
        line.setAttribute('js-ingredients-rest', '');
        line.classList.add('hidden');
      }
    });

    toggleBtn.classList.remove('hidden');
  }

  function initIngredientsKeyList() {
    const keyListWrapper = document.querySelector('[js-ingredients-key-list]');
    if (!keyListWrapper || !keyListWrapper.parentElement) return;

    const imageCarousel = document.querySelector('#ingredients s-carousel');
    if (!imageCarousel) return;

    const parent = keyListWrapper.parentElement;
    const hasExpandCollapse = keyListWrapper.querySelector('[js-ingredients-toggle]') !== null;
    const desktop = isIngredientsDesktop();

    if (hasExpandCollapse) {
      if (desktop) {
        parent.style.maxHeight = '';
        parent.style.overflowY = '';
      } else {
        parent.style.maxHeight = 'none';
        parent.style.overflowY = 'visible';
      }
    } else {
      if (desktop) {
        parent.style.maxHeight = window.innerWidth > INGREDIENTS_BREAKPOINT_PX
          ? INGREDIENTS_MAX_HEIGHT_DESKTOP
          : INGREDIENTS_MAX_HEIGHT_MOBILE;
        parent.style.height = '100%';
        parent.style.overflowY = 'auto';
      } else {
        parent.style.maxHeight = 'none';
        parent.style.overflowY = 'visible';
      }
    }
  }

  /**
   * Called from onclick in product-editorial-block.liquid. Shows full ingredients list and scrolls to it.
   */
  function displayFullList() {
    const fullList = document.querySelector('#full_list_ingred');
    const keyListWrapper = document.querySelector('[js-ingredients-key-list]');
    const imageCarousel = document.querySelector('#ingredients s-carousel');
    const displayListBtn = document.querySelector('[js-display-list]');

    if (keyListWrapper && imageCarousel) {
      const isDesktop = window.innerWidth > INGREDIENTS_BREAKPOINT_PX;
      const maxHeight = isDesktop ? INGREDIENTS_MIN_HEIGHT_MAX_DESKTOP : INGREDIENTS_MIN_HEIGHT_MAX_MOBILE;
      if (keyListWrapper.offsetHeight <= maxHeight) {
        keyListWrapper.parentElement.style.minHeight =
          (imageCarousel.offsetHeight * INGREDIENTS_MIN_HEIGHT_RATIO) + 'px';
      }
    }

    if (fullList) fullList.classList.remove('hidden');
    if (displayListBtn) displayListBtn.classList.add('hidden');

    if (fullList && fullList.parentElement) {
      fullList.parentElement.style.overflowY = 'scroll';
      const parent = fullList.parentElement;
      const offsetTop = fullList.offsetTop - parent.offsetTop;
      parent.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  }

  const INGREDIENTS_LABEL_FULL = 'Click here to see the full list';
  const INGREDIENTS_LABEL_LESS = 'Show less';

  /**
   * Toggle ingredients "rest" (lines 18+) for block 3. Expands to show rest and changes button to "Show less";
   * collapses on second click. Scoped to the button's context (ingredients block only).
   */
  function toggleIngredientsFullList(btn) {
    if (!btn) return;
    const rest = document.querySelectorAll('[js-ingredients-rest]');
    if (!rest.length) return;
    const isHidden = rest[0].classList.contains('hidden');
    const keyListWrapper = document.querySelector('[js-ingredients-key-list]');
    const parent = keyListWrapper ? keyListWrapper.parentElement : null;

    if (isHidden) {
      rest.forEach(function(el) {
        el.classList.remove('hidden');
      });
      btn.textContent = INGREDIENTS_LABEL_LESS;
      if (parent && isIngredientsDesktop()) {
        parent.style.maxHeight = window.innerWidth > INGREDIENTS_BREAKPOINT_PX
          ? INGREDIENTS_MAX_HEIGHT_DESKTOP
          : INGREDIENTS_MAX_HEIGHT_MOBILE;
        parent.style.overflowY = 'auto';
      }
      if (isIngredientsDesktop()) {
        const imageCarousel = document.querySelector('#ingredients s-carousel');
        if (keyListWrapper && imageCarousel && parent) {
          const maxHeight = window.innerWidth > INGREDIENTS_BREAKPOINT_PX
            ? INGREDIENTS_MIN_HEIGHT_MAX_DESKTOP
            : INGREDIENTS_MIN_HEIGHT_MAX_MOBILE;
          if (keyListWrapper.offsetHeight <= maxHeight) {
            parent.style.minHeight =
              (imageCarousel.offsetHeight * INGREDIENTS_MIN_HEIGHT_RATIO) + 'px';
          }
        }
      }
    } else {
      rest.forEach(function(el) {
        el.classList.add('hidden');
      });
      btn.textContent = INGREDIENTS_LABEL_FULL;
      if (parent) {
        parent.style.maxHeight = '';
        parent.style.overflowY = '';
        parent.style.minHeight = '';
      }
    }
  }

  /**
   * Scroll to a section by id, accounting for header. Used by sticky nav and other PDP links.
   */
  function scrollToBlock(anchor, ev) {
    if (ev) ev.preventDefault();
    const el = document.getElementById(anchor);
    if (!el) return;
    const header = document.querySelector('s-header');
    const headerHeight = header ? header.offsetHeight : 0;
    const y = el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  // Expose for onclick and product-pdp-sticky-nav.js
  window.scrollToBlock = scrollToBlock;
  window.displayFullList = displayFullList;
  window.toggleIngredientsFullList = toggleIngredientsFullList;

  // --- Sticky bar presence: when PDP sticky nav exists, use it for layout height (no scroll-based toggling) ---
  function initPaginationDotsPosition() {
    if (document.querySelector('.pdp-sticky-nav')) {
      document.body.classList.add('pdp-sticky-bar-visible');
    }
  }

  // --- Mobile gallery: lock Swiper height to the aspect-ratio box (prevents tall slides from expanding it) ---
  const MOBILE_GALLERY_BREAKPOINT_PX = 767;

  function syncMobileGalleryHeight() {
    const gallery = document.querySelector('.product .product__images');
    const carousel = document.querySelector('.product .product__images [js-carousel]');
    if (!gallery || !carousel) return;

    if (window.innerWidth > MOBILE_GALLERY_BREAKPOINT_PX) {
      carousel.style.removeProperty('height');
      if (carousel.swiper) {
        carousel.swiper.update();
      }
      return;
    }

    const galleryHeight = gallery.getBoundingClientRect().height;
    if (!galleryHeight) return;

    carousel.style.setProperty('height', galleryHeight + 'px', 'important');
    if (carousel.swiper) {
      carousel.swiper.update();
    }
  }

  function initMobileGalleryHeight() {
    const gallery = document.querySelector('.product .product__images');
    const carouselWrapper = document.querySelector('.product .product__images s-carousel');
    if (!gallery) return;

    const scheduleSync = function() {
      syncMobileGalleryHeight();
      requestAnimationFrame(syncMobileGalleryHeight);
    };

    scheduleSync();
    window.addEventListener('resize', scheduleSync);

    gallery.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) {
        img.addEventListener('load', scheduleSync, { once: true });
      }
    });

    if (carouselWrapper) {
      carouselWrapper.addEventListener('carousel:ready', scheduleSync, { once: true });
    } else if (gallery.querySelector('[js-carousel]')?.swiper) {
      scheduleSync();
    }
  }

  // --- Sticky gallery: only when product info column has more content to scroll (desktop) ---
  const PDP_LAYOUT_BREAKPOINT_PX = 1050;

  function updateGalleryStickyState() {
    if (window.innerWidth < PDP_LAYOUT_BREAKPOINT_PX) {
      document.body.classList.remove('pdp-gallery-can-stick');
      return;
    }
    const infoCol = document.querySelector('.product .product__information');
    if (!infoCol) return;
    const viewportHeight = window.innerHeight;
    const infoHeight = infoCol.offsetHeight;
    if (infoHeight > viewportHeight) {
      document.body.classList.add('pdp-gallery-can-stick');
    } else {
      document.body.classList.remove('pdp-gallery-can-stick');
    }
  }

  function initGallerySticky() {
    updateGalleryStickyState();
    window.addEventListener('resize', updateGalleryStickyState);
  }

  const INFO_SCROLL_CHAIN_THRESHOLD = 8;

  function initInfoColumnScrollChaining() {
    const infoCol = document.querySelector('.product .product__information');
    if (!infoCol) return;

    /* On touch devices skip our handoff so native chaining + overscroll-behavior: auto can scroll the page (avoids bounce). */
    const isTouchDevice = 'ontouchstart' in window || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    infoCol.addEventListener('wheel', function(ev) {
      if (window.innerWidth < PDP_LAYOUT_BREAKPOINT_PX || isTouchDevice) return;
      // The size-chart s-drawer lives inside infoCol in the DOM, so its wheel
      // events bubble here. When the drawer is open, bail out immediately —
      // otherwise the atTop check below fires (infoCol.scrollTop is always 0
      // when the drawer is open) and ev.preventDefault() blocks upward scroll
      // inside the drawer on every fresh trackpad gesture.
      if (document.body.classList.contains('size-chart-open')) return;
      const el = ev.currentTarget;
      const atTop = el.scrollTop <= INFO_SCROLL_CHAIN_THRESHOLD;
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - INFO_SCROLL_CHAIN_THRESHOLD;
      const deltaY = ev.deltaY;
      if (deltaY > 0 && atBottom) {
        ev.preventDefault();
        window.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
      } else if (deltaY < 0 && atTop) {
        ev.preventDefault();
        requestAnimationFrame(function() {
          window.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
        });
      }
    }, { passive: false });
  }

  /**
   * Editorial block 1: split each list item "Key: Value" into two spans for left/right alignment.
   */
  function initEditorialBlock1KeyValueList() {
    const content = document.querySelector('.pdp-editorial-block[data-editorial-block="1"] .pdp-editorial-block__content');
    if (!content) return;
    const listItems = content.querySelectorAll('ul li');
    listItems.forEach(function(li) {
      const text = (li.textContent || '').trim();
      if (!text) return;
      const colonIndex = text.indexOf(':');
      const key = colonIndex >= 0 ? text.slice(0, colonIndex + 1).trim() : text;
      const value = colonIndex >= 0 ? text.slice(colonIndex + 1).trim() : '';
      const keySpan = document.createElement('span');
      keySpan.className = 'pdp-editorial-block__key';
      keySpan.textContent = key;
      const valueSpan = document.createElement('span');
      valueSpan.className = 'pdp-editorial-block__value';
      valueSpan.textContent = value;
      li.textContent = '';
      li.appendChild(keySpan);
      li.appendChild(valueSpan);
    });
  }

  // Run when DOM is ready
  function init() {
    initIngredientsLineLayout();
    initIngredientsTruncation();
    initIngredientsKeyList();
    initPaginationDotsPosition();
    initMobileGalleryHeight();
    initGallerySticky();
    initInfoColumnScrollChaining();
    initEditorialBlock1KeyValueList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
